import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Template } from 'interface'
import axiosClient from 'utils/axiosClient'

const initialState: {
  templates: Template[]
} = {
  templates: [],
}

export const getQuizTemplates = createAsyncThunk(
  'Quiz/getQuizTemplates',
  async () => {
    const { data } = await axiosClient.get('/api/templates/')
    return data
  }
)
export const getQuizTemplate = createAsyncThunk(
  'Quiz/getQuizTemplate',
  async (id: number) => {
    const { data } = await axiosClient.get('/api/templates/' + id)
    return data
  }
)

export const QuizSlice = createSlice({
  name: 'Quiz',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getQuizTemplates.fulfilled, (state, { payload }) => {
      state.templates = payload
    })
    builder.addCase(getQuizTemplate.fulfilled, (state, { payload }) => {
      const template = payload as Template
      const index = state.templates.findIndex((f) => f.id === template.id)
      if (index >= 0) {
        state.templates.splice(index, 1, template)
      } else {
        state.templates.unshift(template)
      }
    })
  },
})

export const QuizAction = QuizSlice.actions

export const QuizReducer = QuizSlice.reducer
